import { addAdditionalProps } from 'global/optionLists/additionalProps';
import { useMemo } from 'react';

export const useViewProps = ({ form_state, viewProps, propSectionProps }) => {

  const { formKey, viewItem, formProps, dataOptions, swipedItem, allowImage, isDataContext, isViewSettingsContext } = form_state ?? {}

  const normalProps = useMemo(() => {

    if (viewItem && viewItem.propSections) {
      const _normalProps = getNormalProps(viewItem, viewProps, formProps, dataOptions, swipedItem, allowImage, isDataContext, isViewSettingsContext)
      return _normalProps
    } else if (viewProps) {
      const _normalProps = getNormalProps(viewItem, viewProps, formProps, dataOptions, swipedItem, allowImage, isDataContext, isViewSettingsContext)
      return _normalProps
    }
  }, [viewProps, formKey])

  return { viewProps_normal: normalProps, propSectionProps }

};

const getNormalProps = (viewItem, viewProps, formProps, dataOptions, swipedItem, allowImage, isDataContext, isViewSettingsContext) => {

  addAdditionalProps(swipedItem, viewProps, viewItem, dataOptions, allowImage)

  const { editableItem } = formProps ?? {}

  let props_normal;

  if (isViewSettingsContext) {
    props_normal = { ...viewProps }
  } else if (isDataContext && !editableItem) {
    const { props } = viewItem ?? {}
    props_normal = props ? { ...props } : { ...viewProps }
  } else {
    props_normal = { ...viewProps }
  }
  return props_normal
}
